import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <nav style={{
      background: "var(--white)",
      borderBottom: "1px solid var(--stone)",
      padding: "0 24px",
      height: 60,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "sticky",
      top: 0,
      zIndex: 100,
    }}>
      {/* Logo / 品牌 */}
      <div
        onClick={() => navigate("/")}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}
      >
        <div style={{
          width: 36, height: 36, borderRadius: 9,
          background: "var(--ink)",
          display: "flex", alignItems: "center", justifyContent: "center",
          overflow: "hidden", flexShrink: 0,
        }}>
          <img src="/logo.png" alt="馭雪 YUXUE"
            style={{ width: "76%", height: "76%", objectFit: "contain" }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <span style={{ fontFamily: "'Noto Serif TC', serif", fontSize: 19, fontWeight: 600, letterSpacing: ".06em" }}>
            馭雪
          </span>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 9.5, letterSpacing: ".32em", color: "var(--muted)", marginTop: 2 }}>
            YUXUE
          </span>
        </div>
      </div>

      {/* 右側 */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {user ? (
          <>
            {user.role === "admin" && (
              <button
                onClick={() => navigate("/admin/dashboard")}
                className="btn btn-outline"
                style={{ padding: "8px 16px", fontSize: 14 }}
              >
                管理後台
              </button>
            )}
            {user.role === "coach" && (
              <button
                onClick={() => navigate("/coach/dashboard")}
                className="btn btn-outline"
                style={{ padding: "8px 16px", fontSize: 14 }}
              >
                教練後台
              </button>
            )}
            {user.role === "student" && (
              <button
                onClick={() => navigate("/bookings")}
                className="btn btn-outline"
                style={{ padding: "8px 16px", fontSize: 14 }}
              >
                我的預約
              </button>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 34, height: 34, borderRadius: "50%",
                background: "var(--ink)", color: "var(--white)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 14, fontWeight: 500, overflow: "hidden",
              }}>
                {user.avatar_url
                  ? <img src={user.avatar_url} alt={user.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  : user.name?.[0] || "?"
                }
              </div>
              <button
                onClick={handleLogout}
                style={{ background: "none", color: "var(--muted)", fontSize: 14, cursor: "pointer" }}
              >
                登出
              </button>
            </div>
          </>
        ) : (
          <>
            <button onClick={() => navigate("/login")} className="btn btn-outline" style={{ padding: "8px 16px", fontSize: 14 }}>登入</button>
            <button onClick={() => navigate("/register")} className="btn btn-primary" style={{ padding: "8px 16px", fontSize: 14 }}>註冊</button>
          </>
        )}
      </div>
    </nav>
  );
}